<template>
  <div class="top-nav">
    <div id="logo" :class="logoClasses">
      <a href="/">
        <img :src="LargeLogo" class="full-logo" alt="CandleScience" />
        <img :src="SmallLogo" class="small-logo" alt="CandleScience" />
      </a>
    </div>

    <div id="utility">
      <search-form
        :activated="searchActivated"
        @toggle-search="searchActivated = $event"
      />
      <template v-if="userSignedIn">
        <a :href="accountPath" class="header-login-trigger darker-button">
          <span class="glyphicon glyphicon-user" />
          <span class="trigger-text hidden-xs">My Account</span>
        </a>
        <a :href="logoutPath" class="header-login-trigger lighter-button">
          <span class="glyphicon glyphicon-log-out" />
          <span class="trigger-text hidden-xs">Logout</span>
        </a>
      </template>
      <template v-else>
        <a :href="loginPath" class="header-login-trigger darker-button">
          <span class="glyphicon glyphicon-log-in" />
          <span class="trigger-text hidden-xs">Log in</span>
        </a>
        <a :href="signupPath" class="header-login-trigger lighter-button">
          <span class="glyphicon glyphicon-user" />
          <span class="trigger-text hidden-xs">Sign up</span>
        </a>
      </template>
      <a class="header-cart-link" :href="cartPath">
        <span class="icon-cart" aria-label="Cart" />
        <cart-badge :item-quantity="itemQuantity" />
      </a>
      <a id="nav-toggle" class="visible-xs-block">
        <span class="glyphicon glyphicon-th-list" aria-label="Cart" />
      </a>
    </div>
  </div>
</template>

<script>
  import LargeLogo from "images/logos/large-logo.png"
  import SmallLogo from "images/logos/small-logo.png"
  import CartBadge from "components/storefront/cart-badge"
  import SearchForm from "./search-form"

  export default {
    components: {
      SearchForm,
      CartBadge,
    },
    props: {
      accountPath: { type: String, required: true },
      cartPath: { type: String, required: true },
      logoutPath: { type: String, required: true },
      loginPath: { type: String, required: true },
      signupPath: { type: String, required: true },
      userSignedIn: { type: Boolean, required: true },
      itemQuantity: { type: Number, required: true, default: 0 },
    },
    data() {
      return {
        searchActivated: false,
        LargeLogo,
        SmallLogo,
      }
    },
    computed: {
      logoClasses() {
        return this.searchActivated ? "shrunk" : ""
      },
    },
  }
</script>
